import { ref } from 'vue';

interface Notification {
    id: number;
    message: string;
    type: 'success' | 'error' | 'warning' | 'info';
    duration?: number;
}

const notifications = ref<Notification[]>([]);
let idCounter = 0;

const addNotification = (notification: Omit<Notification, 'id'>) => {
    const id = idCounter++;
    const newNotification: Notification = { ...notification, id };
    notifications.value.push(newNotification);

    if (notification.duration) {
        const currentId = id;
        setTimeout(() => {
            removeNotificationById(currentId);
        }, notification.duration);
    }
};

const removeNotificationById = (id: number) => {
    const index = notifications.value.findIndex((n) => n.id === id);
    if (index !== -1) {
        notifications.value.splice(index, 1);
    }
};

const notifyStatusChange = (oldStatus: string, newStatus: string) => {
    addNotification({
        message: `Status alterado de ${oldStatus} para ${newStatus}`,
        type: 'info',
        duration: 5000
    });
};

export const useNotification = () => {
    return {
        notifications,
        addNotification,
        removeNotificationById,
        notifyStatusChange
    };
};
